import React, { Fragment } from 'react';

import PropTypes from 'prop-types';

import Table from '../../../../common/Table';

import DateCell from '../../../../common/cells/DateCell';

import { CURRENCY, DATE_TIME_FORMAT } from '../../../../../config/locale';

import { numberFormatter } from '../../../../../utils/number';

const BankDepositInformationResource = ({ contractDepositList }) => {
  if (!contractDepositList || contractDepositList.length === 0) {
    return null;
  }

  const totalDeposited = contractDepositList.reduce(
    (total, deposit) => total + Number(deposit.actualAmountDeposited || 0),
    0,
  );

  return (
    <Fragment>
      <h3>Depósitos</h3>

      <div className="mb-3">
        <Table
          columns={[
            {
              Header: 'Banco',
              accessor: 'bankAccount.bank.name',
              className: 'text-center',
              Cell: (row) => row.value || '-',
            },

            {
              Header: 'Cuenta Bancaria',
              accessor: 'bankAccount.accountNumber',
              className: 'text-center',
              Cell: (row) => row.value || '-',
            },

            {
              Header: 'Agencia',
              accessor: 'agency.name',
              className: 'text-center',
              Cell: (row) => row.value || '-',
            },

            {
              Header: 'N° de Operación',
              accessor: 'operationNumber',
              className: 'text-center',
              Cell: (row) => row.value || '-',
            },

            {
              Header: 'Fecha de Depósito',
              accessor: 'depositDate',
              className: 'text-center',
              Cell: (row) => (
                <DateCell value={row.value} format={DATE_TIME_FORMAT} />
              ),
            },

            {
              Header: 'Monto Depositado',
              accessor: 'actualAmountDeposited',
              className: 'text-center',
              Cell: (row) =>
                numberFormatter({
                  value: row.value || 0,
                }),
            },
            {
              Header: 'Aprobado',
              accessor: 'approved',
              Cell: (row) => (
                <input type="checkbox" checked={row.value} readOnly />
              ),
              className: 'text-center',
              filterable: false,
            },
          ]}
          data={contractDepositList}
          defaultPageSize={contractDepositList.length}
          showPagination={false}
        />

        <div className="text-right mt-3">
          <strong>
            Total Depositado:{' '}
            {numberFormatter({
              value: totalDeposited,
            })}{' '}
            {CURRENCY}
          </strong>
        </div>
      </div>
    </Fragment>
  );
};

BankDepositInformationResource.propTypes = {
  contractDepositList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,

      operationNumber: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),

      depositDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
      ]),

      actualAmountDeposited: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),

      approved: PropTypes.bool,

      agencyPayment: PropTypes.bool,

      bankAccount: PropTypes.shape({
        accountNumber: PropTypes.string,

        bank: PropTypes.shape({
          name: PropTypes.string,
        }),
      }),

      agency: PropTypes.shape({
        id: PropTypes.number,

        name: PropTypes.string,
      }),
    }),
  ),
};

BankDepositInformationResource.defaultProps = {
  contractDepositList: [],
};

export default BankDepositInformationResource;
